export const PROPERTY_BODY = 'body';
export const PROPERTY_LABEL = 'label';
export const PROPERTY_LABEL_BEFORE = 'beforeLabel';
export const PROPERTY_LABEL_AFTER = 'afterLabel';
export const PROPERTY_ALIAS = 'alias';
